import api from './api';

const SchoolService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/schools/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/schools/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/schools/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/schools/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/schools/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/schools/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default SchoolService;
